module.exports = __webpack_public_path__ + "media/images/country_flags/sk-39a403a4a2bbbe8ad05daf3e58e3c0bd.png";